export default function (cli) {
  // ADMIN権限が必要なauth絡みのAPI
  return {
    changeLoginAsShop (shop) {
      // 店舗としてログインし直す
      const data = {shop}
      return cli.post(`${cli.apiEndpoint}admin/auth/change-login/`).send(data)
    },
    changeLoginAsGroup (group) {
      // グループとしてログインし直す
      const data = {group}
      return cli.post(`${cli.apiEndpoint}admin/auth/change-login/`).send(data)
    },
  }
}



// WEBPACK FOOTER //
// ./src/api/admin/auth.js